<template>
  <section>
    <card>
      <card-header :title="$t('device_compromised.title') + ':'+ device.display">

      </card-header>
      <card-content>
          <form>
            <fieldset>
              <template v-if="true">
                <div class="field">
                  <div class="control">
                    <textarea 
                      class="textarea" 
                      :placeholder="$t('device_compromised.comment')"
                      v-model="form.comment"></textarea>

                  </div>
                </div>
              </template>
            </fieldset>
          </form>
      </card-content>
      <card-footer>
        <a class="card-footer-item" @click="send()">{{ $t('editing.send') }}</a>
        <a class="card-footer-item" @click="cancel()">{{
          $t('editing.cancel')
        }}</a>
      </card-footer>
    </card>
  </section>
</template>
<script>
import deviceAPI from "@/services/devices";
import { Card, CardContent } from "@/components";
export default {
  name: "DeviceCompromised",
  components: {
    Card,
    CardContent
  },
  data() {
    return {
      device:{
        display: ''
      },
      form: {
        comment: "",
      },
      invalid: false,
      sessionApps: [],
      lastLogins: []
    };
  },
  methods: {
    fetch() {
      deviceAPI.personalDevices().then(
        resp=>{
          this.device = resp.data.find( value =>{
            return value.id == this.id
          })
          if(this.isAllowedToSendRequest() == false){
            this.$router.push('/sessions')
            return
          }
        },
        err => {
          console.log(err);
        }
      )
    },
    isAllowedToSendRequest(){
      return this.device.status.toLowerCase() == "active"
    },
    cancel(){
      this.$router.push('/sessions')
    },
    send(){
      if(this.isAllowedToSendRequest() == false){
        this.$router.push('/sessions')
        return
      }
      deviceAPI.deviceCompromised(this.id, this.form.comment).then(()=>{
        this.$router.push('/sessions')
      }, err =>{
        console.log(err)
      })
    }
  },
  computed : {
    id() {
      return this.$route.params["id"]
    }
  },
  filters: {
    date(value) {
      return new Date(value).toLocaleString();
    }
  },
  mounted() {
    this.fetch();
  }
};
</script>
  